import PlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIService";
import PlaySessionModel from "../ngt/playsession/PlaySessionModel";

export default class CollaborationPlatformAPIService extends PlatformAPIService {
    /**
     * @param {BaseSaveModel} saveModel 
     * @param {soma.EventDispatcher} dispatcher
     * @param {PlaySessionModel} playSessionModel
     */
    constructor(saveModel, dispatcher, playSessionModel) {
        super(saveModel, dispatcher);

        this._playSessionModel = playSessionModel;
    }
}